// Dependencies
import React from 'react';
import radium from 'radium';
import LeoPopup from '../popup/LeoPopup.jsx';
import { ThemeContext } from '../theme/Theme.jsx'

// Styles
import './Footer.scss';

class footer extends React.Component {

	constructor(props, context) {
		super(props);

		this.state = {
			showPopupAgb: false,
			showPopupImprint: false,
			showDataProtection: false,
		};

		this.style = {
			footer: {
				fontSize: context.themeManager.value('footer', 'fontSize', 'font-size-80'),
				background: context.themeManager.value('footer', 'background'),
				marginTop: context.themeManager.valueOrDefault('footer', 'marginTop', null, '1em'),
			},
			footerText: {
				color: context.themeManager.value('footer', 'colorText', 'fg-color-footer-text'),
				borderBottomColor: context.themeManager
					.value('footer', 'linksBorderTopColor', 'fg-color-footer-text-border-botoom'),
			},
			footerLinks: {},
			footerAgb: {
				display: context.themeManager.value('footer', 'displayAgb'),
				background: "transparent",
				border: "none",
				color: context.themeManager.value('footer', 'colorLinks', 'fg-color-footer-links'),
			},
			footerImprint: {
				display: context.themeManager.value('footer', 'displayImprint'),
				background: "transparent",
				border: "none",
				color: context.themeManager.value('footer', 'colorLinks', 'fg-color-footer-links'),
			},
			footerDataProtection: {
				background: "transparent",
				border: "none",
				color: context.themeManager.value('footer', 'colorLinks', 'fg-color-footer-links'),
			}
		};

		this.toggleAgbPopup = this.toggleAgbPopup.bind(this);
		this.toggleImprintPopup = this.toggleImprintPopup.bind(this);
		this.toogleDataProtection = this.toogleDataProtection.bind(this);
	}

	toggleAgbPopup() {
		this.setState({
			showPopupAgb: !this.state.showPopupAgb,
		});
	}

	toggleImprintPopup() {
		this.setState({
			showPopupImprint: !this.state.showPopupImprint,
		});
	}

	toogleDataProtection() {
		this.setState({
			showDataProtection: !this.state.showDataProtection,
		});
	}

	render() {
		return (
			<footer className="footer" style={[this.style.footer, this.props.style]}>
				<div
					className="footer__text"
					style={this.style.footerText}
					dangerouslySetInnerHTML={{ __html: this.context.themeManager.getThemeText('footerText') }}
				/>
				<div
					className="footer__links"
					style={this.style.footerLinks}
				>
					<button style={this.style.footerAgb} onClick={this.toggleAgbPopup} title={"AGBs in Popup öffnen"}>AGB</button>
					<button style={this.style.footerImprint} onClick={this.toggleImprintPopup} title={"Impressum in Popup öffnen"}>Impressum</button>
					{this.context.themeManager.getThemeText('dataProtectionPopupText') &&  // Feature Toggle
						<button style={this.style.footerDataProtection}  title={"Dateschutz in Popup öffnen"} onClick={this.toogleDataProtection}>Datenschutz</button>
					}
				</div>


				{this.state.showPopupAgb &&
					<LeoPopup
						headline={this.context.themeManager.getThemeText('agbPopupHeadline')}
						onClose={this.toggleAgbPopup}
					>
						{this.context.themeManager.getThemeText('agbPopupText')}
					</LeoPopup>
				}

				{this.state.showPopupImprint &&
					<LeoPopup
						headline={this.context.themeManager.getThemeText('imprintPopupHeadline')}
						onClose={this.toggleImprintPopup}
					>
						{this.context.themeManager.getThemeText('imprintPopupText')}
					</LeoPopup>
				}

				{this.state.showDataProtection &&
					<LeoPopup
						headline={this.context.themeManager.getThemeText('dataProtectionPopupHeadline')}
						onClose={this.toogleDataProtection}
					>
						{this.context.themeManager.getThemeText('dataProtectionPopupText')}
					</LeoPopup>
				}
			</footer>

		);
	}
}

footer.contextType = ThemeContext;

export default radium(footer);

